<div class="text--large" data-test="new-invoices-subtitle" style="line-height: 1.5rem">
  @if (!isStorniert()) {
    @for (category of categories(); track category) {
      <span>{{ category | translateCategory }}</span>
      @if (!$last) {
        <span> und </span>
      }
    }
    |
  }
  <span>{{ invoiceDate() }}</span>
  @if (hasPriceColor()) {
    | <span>{{ 'interactive-invoices.invoice-cards.credit' | translate }}</span>
  }
</div>
